import * as React from 'react';
import { CnFormField } from '@/form/cn-form-field';
import { CnFilter as CnFilterView } from './cn-filter';
import locale from '@/locale';
import { withI18n } from 'panda-i18n';
import './index.scss';
const CnFilterItem = (props) => {
    return React.createElement(CnFormField, { title: props.label, ...props });
};
CnFilterItem.displayName = 'CnFilterItem';
const CnFilterProItem = (props) => {
    return React.createElement(CnFilterItem, { ...props });
};
CnFilterProItem.displayName = 'CnFilterProItem';
const CnFilter = withI18n(CnFilterView, {
    locale,
    componentName: 'CnFilter',
    _noHoc: true,
});
const CnFilterPro = (props) => {
    return React.createElement(CnFilter, { ...props });
};
CnFilterPro.displayName = 'CnFilterPro';
// const CnFilter = CnFilterView;
export { CnFilter, CnFilterPro, CnFilterItem, CnFilterProItem };
